export const semaforoColors = {
  Verde: "#52c41a",
  Amarillo: "#faad14",
  Rojo: "#ff4d4f",
  Gris: "#bfbfbf",
};

export const getSemaforoCumplimiento = ({ facturasPagadas = 0, porcentajeCumplimiento = 0 }) => {
  if (Number(facturasPagadas) === 0) return "Gris";
  if (Number(porcentajeCumplimiento) >= 100) return "Verde";
  if (Number(porcentajeCumplimiento) > 0) return "Amarillo";
  return "Rojo";
};

export const formatCumplimiento = (value) => `${Number(value || 0)}%`;

export const normalizePercent = (value) => {
  const porcentaje = Number(value || 0);
  return Math.min(100, Math.max(0, porcentaje));
};

export const semaforoOrder = {
  Rojo: 1,
  Amarillo: 2,
  Verde: 3,
  Gris: 4,
};

export const semaforoFilters = [
  { text: "Rojo", value: "Rojo" },
  { text: "Amarillo", value: "Amarillo" },
  { text: "Verde", value: "Verde" },
  { text: "Gris", value: "Gris" },
];

export const cumplimientoFilters = [
  { text: "0% - 49%", value: "0-49" },
  { text: "50% - 99%", value: "50-99" },
  { text: "100%", value: "100-100" },
];

export const compareText = (a, b, dataIndex) => {
  return String(a[dataIndex] || "").localeCompare(String(b[dataIndex] || ""));
};

export const compareNumber = (a, b, dataIndex) => {
  return Number(a[dataIndex] || 0) - Number(b[dataIndex] || 0);
};

export const filterCumplimientoRange = (value, record) => {
  const [min, max] = String(value).split("-").map(Number);
  const porcentaje = normalizePercent(record.porcentajeCumplimiento);

  return porcentaje >= min && porcentaje <= max;
};

export const matchesCumplimientoRanges = (ranges, record) => {
  if (!ranges.length) return true;
  return ranges.some((range) => filterCumplimientoRange(range, record));
};

export const matchesTextSearch = (search, value) => {
  if (!search) return true;
  return String(value || "").toLowerCase().includes(search.toLowerCase());
};

export const buildAlertasFromProveedores = (proveedores) => {
  return proveedores
    .filter((item) => Number(item.diferencia || 0) > 0)
    .map((item, index) => ({
      ...item,
      id: item.id || `${item.proveedor}-${index}`,
      tipo: "Complemento pendiente",
      semaforo: getSemaforoCumplimiento(item),
    }));
};
